import { DotDateCard } from '@components/UI/DotDateCard/DotDateCard';
import { ICTask } from '@Helper/Interfaces';
import { getPlayBookDetail } from '@Store/feature/playBookDetailSlice';
import { useAppSelector } from '@Store/hooks';
import React, { FC } from 'react';
import { getTaskColor } from '../helper';

type IProps = {
  data: any;
  updateTaskProperty?: (taskId: string, property: string, value: any) => any;
  editable?: boolean;
};

const DueDateCell: FC<IProps> = ({ data, updateTaskProperty, editable }) => {
  const { dealTaskList } = useAppSelector(getPlayBookDetail);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        justifyContent: 'center',
      }}
    >
      <DotDateCard
        disabled={!editable}
        isEditable={editable ?? true}
        color={getTaskColor(data.data.data, dealTaskList)}
        value={
          data.data.data.dueDate !== null
            ? data.data.data.dueDate.split('T')[0]
            : data.data.text
        }
        updateTaskDate={(currentTask: ICTask, taskDate: string) => {
          updateTaskProperty &&
            updateTaskProperty(
              currentTask.id!,
              'dueDate',
              taskDate !== '' ? taskDate : null
            );
        }}
        task={data.data.data}
      />
    </div>
  );
};

export default DueDateCell;
